import { IReadOptions } from "@samc/common";
import { GetDeliveryOptions, DeliveryOption } from '@samc/querybuilder';
import { CachedDataSource } from './BaseDataSources';

export class LSDeliveryOptionSource extends CachedDataSource<any> {
  protected async loadData(options: IReadOptions, abortController?: AbortController | undefined): Promise<DeliveryOption[]> {
    return await GetDeliveryOptions();
  }
}